import clsx from 'clsx';
import type { SalesRep } from '../team';

interface RepBadgeProps {
  rep: SalesRep;
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
  className?: string;
}

export function RepBadge({ rep, size = 'sm', showName = false, className }: RepBadgeProps) {
  const dimensions = {
    sm: 'h-6 w-6 text-[10px]',
    md: 'h-8 w-8 text-xs',
    lg: 'h-10 w-10 text-sm',
  }[size];

  return (
    <span className={clsx('inline-flex items-center gap-2', className)}>
      <span
        className={clsx(
          'inline-flex items-center justify-center rounded-full bg-surface-sunken font-medium text-text-secondary',
          dimensions,
        )}
        title={rep.name}
      >
        {rep.initials}
      </span>
      {showName && <span className="text-body-sm text-text-primary">{rep.name}</span>}
    </span>
  );
}
